import { render } from "./RegisterPage.vue?vue&type=template&id=58cc28e9&scoped=true"
import script from "./RegisterPage.vue?vue&type=script&lang=js"
export * from "./RegisterPage.vue?vue&type=script&lang=js"

import "./RegisterPage.vue?vue&type=style&index=0&id=58cc28e9&scoped=true&lang=css"

import exportComponent from "/Users/kaho/cloudfit-pro-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58cc28e9"]])

export default __exports__